import api from '../services/api';
import { toast } from 'react-toastify';
import { getText } from './translations';

// Fonte única (no BACK) da próxima etapa do fluxo do convidado. O back devolve uma CHAVE de step
// (no campo `proximoStep` do GET das telas, ou pelo endpoint /participante/{id}/proximoStep); este
// módulo só mapeia chave -> rota e navega. A decisão (ordem, atalho de aéreo, diferença de
// palestrante) vive no back — ver ParticipanteController::proximoStepPendente.

// Mapeia a chave de step para a rota do front. `concluido` usa o id do EVENTO; os demais, o id do
// PARTICIPANTE. `carta` propaga o ?contrato=true quando presente.
export function rotaDoStep(step, { id, eventoId, contrato }) {
  switch (step) {
    case 'carta':
      return `/cadastroEventoParticipanteAceitarConvite/${id}${contrato ? '?contrato=true' : ''}`;
    case 'termo':
      return `/cadastroEventoParticipanteAceitarTermo/${id}`;
    case 'cartaInformativa':
      return `/cadastroEventoParticipanteCartaInformativa/${id}`;
    case 'dados':
      return `/cadastroEventoParticipanteConvite/${id}`;
    case 'aereo':
      return `/cadastroEventoParticipanteAereoConvite/${id}`;
    case 'transfer':
      return `/cadastroEventoParticipanteTransferConvite/${id}`;
    case 'hotel':
      return `/cadastroEventoParticipanteHotelConvite/${id}`;
    case 'recusado':
      return `/cadastroEventoParticipanteConviteRecusado/${eventoId}`;
    case 'concluido':
    default:
      return `/cadastroEventoParticipanteConviteConcluido/${eventoId}`;
  }
}

// Pergunta ao back a próxima etapa (pós-ação, estado fresco) e navega. Mostra o overlay de load
// durante o GET (setLoading) para a tela não parecer travada. Em erro, libera o load e avisa.
export async function irParaProximoStep(history, { id, token, eventoId, contrato, setLoading }) {
  try {
    if (setLoading) setLoading(true);
    const r = await api({ method: 'get', action: `/participante/${id}/proximoStep`, token });
    if (setLoading) setLoading(false);
    history.push(rotaDoStep(r.data.proximoStep, { id, eventoId, contrato }));
  } catch (e) {
    if (setLoading) setLoading(false);
    toast.error(getText('error') + getText('errorRefreshPage'));
  }
}
